





import { Vue, Component } from "vue-property-decorator";
import BusinessTable from "@/modules/businesses/components/BusinessesTable.vue";
@Component({
  components: {
    businesses: BusinessTable,
  },
})
export default class Integration extends Vue {}
